import { render, staticRenderFns } from "./InfoServiceType.vue?vue&type=template&id=955265ec&scoped=true"
import script from "./InfoServiceType.vue?vue&type=script&lang=js"
export * from "./InfoServiceType.vue?vue&type=script&lang=js"
import style0 from "./InfoServiceType.vue?vue&type=style&index=0&id=955265ec&prod&scoped=true&lang=css"
import style1 from "./InfoServiceType.vue?vue&type=style&index=1&id=955265ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955265ec",
  null
  
)

export default component.exports